import LinearProgress from '@mui/material/LinearProgress';
import dynamic from 'next/dynamic';
import { useGoogleLogin } from '../../hooks';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const Login = dynamic(() => import('@t2c/auth').then((lib) => lib.Login), {
  loading: () => <LinearProgress />,
});

export const LandingPage = () => {
  const { push } = useRouter();
  const { handleGoogleLoginSuccess, handleOnError, isLoading, isLoggedIn } = useGoogleLogin({
    shouldRedirectOnSuccess: true,
  });

  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const handleRedirect = () => {
    // if (isExtraSmall) {
    //   push('/broll');
    // } else {
    // push('/dashboard');
    // }
    push('/text-to-image');
  };

  useEffect(() => {
    if (isLoggedIn) handleRedirect();
  }, [isLoggedIn]);

  return (
    <Login
      onSuccess={handleGoogleLoginSuccess}
      onError={handleOnError}
      isLoading={isLoading}
      isLoggedIn={isLoggedIn}
      redirectBtnText="Go To Dashboard"
      handleRedirect={handleRedirect}
    />
  );
};
